import { Route } from 'react-router-dom';
import FHIRWebLaunch from './components/FHIRLaunch';
import FHIRCallback from './components/FHIRCallback';
import EHRCallback from './components/EHRCallback';
import EPICLaunch from './components/EPICLaunch';

export const getFHIRPublicRoutes = () => {
  const pages = [
    {
      path: '/fhir/launch',
      Component: FHIRWebLaunch,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};

export const getFHIRRoutes = () => {
  const pages = [
    {
      path: '/fhir/callback',
      Component: FHIRCallback,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};

export const getEPICRoutes = () => {
  const pages = [
    {
      path: '/epic/launch/:sessionId',
      Component: EPICLaunch,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};

export const getEHRRoutes = () => {
  const pages = [
    {
      path: '/ehr/callback',
      Component: EHRCallback,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return <Route key={index} path={path} element={<Component />} />;
  });
};
